<script setup lang="ts">
import UIBody from '@/components/ui/UIBody.vue'
import {
  PhCalendarBlank,
  PhCubeTransparent,
  PhMoney,
  PhRuler,
  PhShootingStar
} from '@phosphor-icons/vue'
import { ref } from 'vue'

defineProps<{
  /** The icon to display */
  icon?: keyof typeof componentMapping
  alt?: string
  /** The text content of the item */
  text?: string
  /** Whether the item should take up the full width on mobile */
  fullWidth?: boolean
}>()

const componentMapping = {
  PhShootingStar: PhShootingStar,
  PhMoney: PhMoney,
  PhCubeTransparent: PhCubeTransparent,
  PhRuler: PhRuler,
  PhCalendarBlank: PhCalendarBlank
}

const isHovered = ref(false)
</script>

<template>
  <div
    role="listitem"
    class="flex items-start sm:items-center"
    :class="
      fullWidth
        ? 'w-full flex-col space-y-1 sm:w-auto sm:flex-row sm:space-y-0 sm:space-x-1'
        : 'space-x-1 w-1/2 sm:w-auto'
    "
    @mouseover="isHovered = true"
    @mouseleave="isHovered = false"
  >
    <component
      :is="componentMapping[icon]"
      v-if="icon"
      :size="20"
      :weight="isHovered ? 'duotone' : 'regular'"
      class="fill-charcoal shrink-0"
      :role="alt ? 'img' : undefined"
      :aria-label="alt"
      :aria-hidden="alt ? undefined : 'true'"
    />
    <slot name="customIcon"></slot>
    <UIBody v-if="text" size="sm" weight="medium" :text="text" />
    <slot></slot>
  </div>
</template>
